import type { SimilarPartResult } from '@frontend/api';

import { INIT_EDIT_QUOTE } from 'store/quotes/types';

import {
  OPEN_SIMILAR_COMPONENTS_MODAL,
  CLOSE_SIMILAR_COMPONENTS_MODAL,
  type SimilarComponentsModalAction,
} from './actions';

export interface SimilarComponentsModalState {
  componentId: number | null;
  isOpen: boolean;
  similarParts: SimilarPartResult[];
}

const initialState: SimilarComponentsModalState = {
  componentId: null,
  isOpen: false,
  similarParts: [],
};

export default function similarComponentsModal(
  state = initialState,
  action: SimilarComponentsModalAction | { type: typeof INIT_EDIT_QUOTE },
): SimilarComponentsModalState {
  const { type } = action;

  switch (type) {
    case INIT_EDIT_QUOTE:
      return { ...initialState };
    case OPEN_SIMILAR_COMPONENTS_MODAL:
      return {
        ...state,
        componentId: action.payload.componentId,
        similarParts: action.payload.similarParts,
        isOpen: true,
      };
    case CLOSE_SIMILAR_COMPONENTS_MODAL:
      return { ...initialState };
    default:
      return state;
  }
}
